export const getBadgeKeys = <
  T extends {
    attributes?: Record<string, any>;
    optional?: boolean;
    properties?: Record<string, any>;
  }
>(
  params: T
) => {
  const paramsObject = {
    ...(params.optional ? { optional: true } : {}),
    ...params.attributes,
    ...params.properties,
  };
  return Object.entries(paramsObject)
    .filter(([_, value]) => Boolean(value))
    .map(([key, _]) => key);
};
